import { useScreen } from "hooks";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

import { Title, StyledFitText, StyledPlaceholder } from "./styles";

const TemplateGroupTitle = ({ templateGroup }) => {
  const { isMobile } = useScreen();

  const isInvite = TemplateGroupPresenter.isInvite(templateGroup);
  const title = isInvite ? TemplateGroupPresenter.mainTitle(templateGroup) : TemplateGroupPresenter.name(templateGroup);

  const renderPlaceholder = () => {
    return <StyledPlaceholder data-testid="placeholder" variant="text" align="center" />;
  };

  const renderTitle = () => {
    return (
      <Title component="h1" variant="h2" align="center">
        {isMobile ? <StyledFitText max={20}>{title}</StyledFitText> : <>{title}</>}
      </Title>
    );
  };

  return templateGroup ? renderTitle() : renderPlaceholder();
};

TemplateGroupTitle.propTypes = {
  templateGroup: TemplateGroupPresenter.shape(),
};

export default TemplateGroupTitle;
